module.exports = __webpack_public_path__ + "img/xmatch.eca024e.png";